import React from "react";
import { Skeleton } from "antd";
import "./Blogs.css"
export const BlogSkeleton = () => {
  return (
    <div
      className="skeleton-container"
    >
      <Skeleton.Input className="skeleton-class" active={true} />
      <Skeleton.Input className="skeleton-class" active={true} />
      <Skeleton.Input className="skeleton-class" active={true} />
      <br />
      <Skeleton className="skeleton-class" active={true} />
    </div>
  );
};
